import { SVGProps } from 'react'

export function CupIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M11.25 18.25H9C7.9 18.25 7 19.15 7 20.25V20.5H6C5.59 20.5 5.25 20.84 5.25 21.25C5.25 21.66 5.59 22 6 22H18C18.41 22 18.75 21.66 18.75 21.25C18.75 20.84 18.41 20.5 18 20.5H17V20.25C17 19.15 16.1 18.25 15 18.25H12.75V15.96C12.5 15.99 12.25 16 12 16C11.75 16 11.5 15.99 11.25 15.96V18.25Z'
				fill='currentColor'
			/>
			<path
				d='M18.4803 11.64C19.1403 11.39 19.7203 10.98 20.1803 10.52C21.1103 9.49 21.7203 8.26 21.7203 6.82C21.7203 5.38 20.5903 4.25 19.1503 4.25H18.5903C17.9403 2.92 16.5803 2 15.0003 2H9.00027C7.42027 2 6.06027 2.92 5.41027 4.25H4.85027C3.41027 4.25 2.28027 5.38 2.28027 6.82C2.28027 8.26 2.89027 9.49 3.82027 10.52C4.28027 10.98 4.86027 11.39 5.52027 11.64C6.56027 14.2 9.06027 16 12.0003 16C14.9403 16 17.4403 14.2 18.4803 11.64ZM14.8403 8.45L14.2203 9.21C14.1203 9.32 14.0503 9.54 14.0603 9.69L14.1203 10.67C14.1603 11.27 13.7303 11.58 13.1703 11.36L12.2603 11C12.1203 10.95 11.8803 10.95 11.7403 11L10.8303 11.36C10.2703 11.58 9.84027 11.27 9.88027 10.67L9.94027 9.69C9.95027 9.54 9.88027 9.32 9.78027 9.21L9.16027 8.45C8.77027 7.99 8.94027 7.48 9.52027 7.33L10.4703 7.09C10.6203 7.05 10.8003 6.91 10.8803 6.78L11.4103 5.96C11.7403 5.45 12.2603 5.45 12.5903 5.96L13.1203 6.78C13.2003 6.91 13.3803 7.05 13.5303 7.09L14.4803 7.33C15.0603 7.48 15.2303 7.99 14.8403 8.45Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function FrameIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path d='M11 19.9V4.1C11 2.6 10.36 2 8.77 2H4.73C3.14 2 2.5 2.6 2.5 4.1V19.9C2.5 21.4 3.14 22 4.73 22H8.77C10.36 22 11 21.4 11 19.9Z' fill='currentColor' />
			<path
				d='M21.5 19.64V15.36C21.5 14.06 20.5 13 19.27 13H15.23C14 13 13 14.06 13 15.36V19.64C13 20.94 14 22 15.23 22H19.27C20.5 22 21.5 20.94 21.5 19.64Z'
				fill='currentColor'
			/>
			<path d='M21.5 8.64V4.36C21.5 3.06 20.5 2 19.27 2H15.23C14 2 13 3.06 13 4.36V8.64C13 9.94 14 11 15.23 11H19.27C20.5 11 21.5 9.94 21.5 8.64Z' fill='currentColor' />
		</svg>
	)
}

export function HomeIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M20.83 8.01002L14.28 2.77002C13 1.75002 11 1.74002 9.72996 2.76002L3.17996 8.01002C2.23996 8.76002 1.66996 10.26 1.86996 11.44L3.12996 18.98C3.41996 20.67 4.98996 22 6.69996 22H17.3C18.99 22 20.59 20.64 20.88 18.97L22.14 11.43C22.32 10.26 21.75 8.76002 20.83 8.01002ZM12.75 18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V15C11.25 14.59 11.59 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15V18Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function BankIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path d='M22 19V22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19Z' fill='currentColor' />
			<path d='M7 11H5V18H7V11Z' fill='currentColor' />
			<path d='M11 11H9V18H11V11Z' fill='currentColor' />
			<path d='M15 11H13V18H15V11Z' fill='currentColor' />
			<path d='M19 11H17V18H19V11Z' fill='currentColor' />
			<path
				d='M23 22.75H1C0.59 22.75 0.25 22.41 0.25 22C0.25 21.59 0.59 21.25 1 21.25H23C23.41 21.25 23.75 21.59 23.75 22C23.75 22.41 23.41 22.75 23 22.75Z'
				fill='currentColor'
			/>
			<path
				d='M21.37 5.74997L12.37 2.14997C12.17 2.06997 11.83 2.06997 11.63 2.14997L2.63 5.74997C2.28 5.88997 2 6.29997 2 6.67997V9.99997C2 10.55 2.45 11 3 11H21C21.55 11 22 10.55 22 9.99997V6.67997C22 6.29997 21.72 5.88997 21.37 5.74997ZM12 8.49997C11.17 8.49997 10.5 7.82997 10.5 6.99997C10.5 6.16997 11.17 5.49997 12 5.49997C12.83 5.49997 13.5 6.16997 13.5 6.99997C13.5 7.82997 12.83 8.49997 12 8.49997Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function UserOctagonIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M19.5099 5.85L13.5699 2.42C12.5999 1.86 11.3999 1.86 10.4199 2.42L4.48992 5.85C3.51992 6.41 2.91992 7.45 2.91992 8.58V15.42C2.91992 16.54 3.51992 17.58 4.48992 18.15L10.4299 21.58C11.3999 22.14 12.5999 22.14 13.5799 21.58L19.5199 18.15C20.4899 17.59 21.0899 16.55 21.0899 15.42V8.58C21.0799 7.45 20.4799 6.42 19.5099 5.85ZM11.9999 7.34C13.2899 7.34 14.3299 8.38 14.3299 9.67C14.3299 10.96 13.2899 12 11.9999 12C10.7099 12 9.66992 10.96 9.66992 9.67C9.66992 8.39 10.7099 7.34 11.9999 7.34ZM14.6799 16.66H9.31992C8.50992 16.66 8.03992 15.76 8.48992 15.09C9.16992 14.08 10.4899 13.4 11.9999 13.4C13.5099 13.4 14.8299 14.08 15.5099 15.09C15.9599 15.75 15.4799 16.66 14.6799 16.66Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function ProfileUsersIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z'
				fill='currentColor'
			/>
			<path
				d='M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z'
				fill='currentColor'
			/>
			<path
				d='M19.9904 7.33998C20.1504 9.27998 18.7704 10.98 16.8604 11.21C16.8504 11.21 16.8504 11.21 16.8404 11.21H16.8104C16.7504 11.21 16.6904 11.21 16.6404 11.23C15.6704 11.28 14.7804 10.97 14.1104 10.4C15.1404 9.47998 15.7304 8.09998 15.6104 6.59998C15.5404 5.78998 15.2604 5.04998 14.8404 4.41998C15.2204 4.22998 15.6604 4.10998 16.1104 4.06998C18.0704 3.89998 19.8204 5.35998 19.9904 7.33998Z'
				fill='currentColor'
			/>
			<path
				d='M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function MoneysIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M19.17 6.64002C18.74 4.47002 17.13 3.52002 14.89 3.52002H6.10996C3.46996 3.52002 1.70996 4.84002 1.70996 7.92002V13.07C1.70996 15.29 2.61996 16.59 4.11996 17.15C4.33996 17.23 4.57996 17.3 4.82996 17.34C5.22996 17.43 5.65996 17.47 6.10996 17.47H14.9C17.54 17.47 19.3 16.15 19.3 13.07V7.92002C19.3 7.45002 19.26 7.03002 19.17 6.64002ZM5.52996 12C5.52996 12.41 5.18996 12.75 4.77996 12.75C4.36996 12.75 4.02996 12.41 4.02996 12V9.00002C4.02996 8.59002 4.36996 8.25002 4.77996 8.25002C5.18996 8.25002 5.52996 8.59002 5.52996 9.00002V12ZM10.5 13.14C9.03996 13.14 7.85996 11.96 7.85996 10.5C7.85996 9.04002 9.03996 7.86002 10.5 7.86002C11.96 7.86002 13.14 9.04002 13.14 10.5C13.14 11.96 11.96 13.14 10.5 13.14ZM16.96 12C16.96 12.41 16.62 12.75 16.21 12.75C15.8 12.75 15.46 12.41 15.46 12V9.00002C15.46 8.59002 15.8 8.25002 16.21 8.25002C16.62 8.25002 16.96 8.59002 16.96 9.00002V12Z'
				fill='currentColor'
			/>
			<path
				d='M22.2998 10.92V16.07C22.2998 19.15 20.5398 20.48 17.8898 20.48H9.10977C8.35977 20.48 7.68977 20.37 7.10977 20.15C6.63977 19.98 6.22977 19.73 5.89977 19.41C5.71977 19.24 5.85977 18.97 6.10977 18.97H14.8898C18.5898 18.97 20.7898 16.77 20.7898 13.08V7.92003C20.7898 7.68003 21.0598 7.53003 21.2298 7.71003C21.9098 8.43003 22.2998 9.48003 22.2998 10.92Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function WalletBoldIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M21.4499 13.64V14.64C21.4499 14.91 21.2399 15.13 20.9599 15.14H19.4999C18.9699 15.14 18.4899 14.75 18.4499 14.23C18.4199 13.92 18.5399 13.63 18.7399 13.43C18.9199 13.24 19.1699 13.14 19.4399 13.14H20.9499C21.2399 13.15 21.4499 13.37 21.4499 13.64Z'
				fill='currentColor'
			/>
			<path
				d='M17.9902 12.69C17.4902 13.18 17.2502 13.91 17.4502 14.67C17.7102 15.6 18.6202 16.19 19.5802 16.19H20.4502C21.0002 16.19 21.4502 16.64 21.4502 17.19V17.38C21.4502 19.45 19.7602 21.14 17.6902 21.14H6.2102C4.1402 21.14 2.4502 19.45 2.4502 17.38V10.65C2.4502 9.42001 3.0402 8.33001 3.9502 7.65001C4.5802 7.17001 5.3602 6.89001 6.2102 6.89001H17.6902C19.7602 6.89001 21.4502 8.58001 21.4502 10.65V11.09C21.4502 11.64 21.0002 12.09 20.4502 12.09H19.4302C18.8702 12.09 18.3602 12.31 17.9902 12.69Z'
				fill='currentColor'
			/>
			<path
				d='M16.2001 4.82C16.4701 5.09 16.2401 5.51 15.8601 5.51L8.18006 5.5C7.74006 5.5 7.51006 4.96 7.83006 4.65L9.45006 3.02C10.8201 1.66 13.0401 1.66 14.4101 3.02L16.1601 4.79C16.1701 4.8 16.1901 4.81 16.2001 4.82Z'
				fill='currentColor'
			/>
		</svg>
	)
}
